// Shown at the top of a page reached via `?return_to=`. Two jobs: tell the
// admin why they are here, and give them a way back that does not depend on
// browser history (they may have navigated within this page since arriving).

import { ArrowLeft } from "lucide-react";

import { Button } from "@/components/ui/primitives";
import { Link } from "@/components/ui/link";
import { describeReturnTo } from "@/lib/return-to";

export function ReturnBanner({ to, noun }: { to: string; noun: string }) {
  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3 rounded-md border border-border bg-muted/40 px-4 py-3">
      <p className="text-sm text-muted-foreground">
        Configuring {noun} for{" "}
        <span className="font-medium text-foreground">{describeReturnTo(to)}</span>. You will be
        taken back once you add one.
      </p>
      <Button variant="ghost" size="sm" asChild>
        <Link href={to}>
          <ArrowLeft className="h-4 w-4" />
          Back
        </Link>
      </Button>
    </div>
  );
}
